import {
  useCdaasCenturionHomepageContent,
  useCdaasCulinaryCollectiveContent,
} from './cdaasFetchyeHooks';

export const useCulinaryCollectiveContent = () => {
  const { data } = useCdaasCulinaryCollectiveContent();
  return data?.body?.data ?? {};
};

export const useCenturionHomepageContent = () => {
  const { data } = useCdaasCenturionHomepageContent();
  return data?.body?.homepage ?? {};
};
